<!--Dashboard loads components dynamically to build the user dashboard-->
<template>
  <v-container>
    <v-row>
      <base-title>
        Dashboard
      </base-title>
    </v-row>
    <v-row>
      <v-col
        v-if="$store.getters.can('frontend.view_cut_weights_dashboard')"
        cols="12"
      >
        <current-cut-weights />
      </v-col>
      <v-col
        v-if="$store.getters.can('frontend.view_check_ins_dashboard')"
        cols="12"
      >
        <current-check-ins />
      </v-col>
      <v-col
        v-if="!$store.getters.can('frontend.view_cut_weights_dashboard') &&
          !$store.getters.can('frontend.view_check_ins_dashboard')"
      >
        <v-card>
          <v-card-text>
            No dashboard components available.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CurrentCutWeights from './components/CurrentCutWeights/CurrentCutWeights'
import CurrentCheckIns from './components/AccountManagers/CurrentCheckIns'

export default {
  name: 'HomeDashboard',
  components: {
    // this method of loading components LAZY loads them
    CurrentCutWeights,
    CurrentCheckIns
  }
}
</script>
